import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config"; // Base API URL
import eyeIcon from "../assets/ic_eye.svg";
import eyeSlashIcon from "../assets/ic_eye.svg"; // Closed-eye icon

const ChangePassword = () => {
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleUpdatePassword = async () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      alert("All fields are required");
      return;
    }
    if (newPassword !== confirmPassword) {
      alert("New password and Confirm password must match");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${config.BASE_URL}/admin/change-password`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          adminId:1,
          oldPassword: currentPassword,
          newPassword,
        }),
      });

      const data = await res.json();
      setLoading(false);

      if (data.success) {
        alert("Password changed successfully");
       // navigate("/dashboard");
      } else {
        alert(data.message || "Failed to change password");
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      alert("Error changing password");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
<h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
  Change Password
</h2>

      {/* Current Password */}
      <div className="mb-4 relative">
        <label className="block text-gray-700 mb-1">Current Password</label>
        <input
          type={showCurrent ? "text" : "password"}
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          className="w-full border border-gray-300 rounded-md p-2 pr-10"
          placeholder="Enter current password"
        />
        <button
          type="button"
          className="absolute right-2 top-1/2 "
          onClick={() => setShowCurrent(!showCurrent)}
        >
          <img
            src={showCurrent ? eyeSlashIcon : eyeIcon}
            alt="Toggle visibility"
            className="w-5 h-5"
          />
        </button>
      </div>

      {/* New Password */}
      <div className="mb-4 relative">
        <label className="block text-gray-700 mb-1">New Password</label>
        <input
          type={showNew ? "text" : "password"}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full border border-gray-300 rounded-md p-2 pr-10"
          placeholder="Enter new password"
        />
        <button
          type="button"
          className="absolute right-2 top-1/2 "
          onClick={() => setShowNew(!showNew)}
        >
          <img
            src={showNew ? eyeSlashIcon : eyeIcon}
            alt="Toggle visibility"
            className="w-5 h-5"
          />
        </button>
      </div>

      {/* Confirm Password */}
 <div className="mb-6 relative">
  <label className="block text-gray-700 mb-1">Confirm Password</label>
  <input
    type={showConfirm ? "text" : "password"}
    value={confirmPassword}
    onChange={(e) => setConfirmPassword(e.target.value)}
    className="w-full border border-gray-300 rounded-md p-2 pr-10"
    placeholder="Confirm new password"
  />
  <button
    type="button"
    className="absolute right-2 top-1/2  "
    onClick={() => setShowConfirm(!showConfirm)}
  >
    <img
      src={showConfirm ? eyeSlashIcon : eyeIcon}
      alt="Toggle visibility"
      className="w-5 h-5"
    />
  </button>
</div>



      <button
        onClick={handleUpdatePassword}
        disabled={loading}
        className={`w-full py-2 px-4 rounded-md text-white font-semibold ${
          loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#000000] hover:bg-[#000000]"
        }`}
      >
        {loading ? "Updating..." : "Update Password"}
      </button>
    </div>
  );
};

export default ChangePassword;
